// Kartets farge for sjåføren: «Følg appen» (standard), «Lyst» eller «Mørkt».
// Lagres på brukeren (users.preferences.mapTheme: 'auto' | 'light' | 'dark'); uten verdi følger kartet appen.

export const MAP_THEME_OPTIONS = [
  { value: 'auto',  label: 'Følg appen', hint: 'Mørkt kart når appen er mørk' },
  { value: 'light', label: 'Lyst' },
  { value: 'dark',  label: 'Mørkt' },
];

export function normalizeMapTheme(pref) {
  return pref === 'light' || pref === 'dark' ? pref : 'auto';
}

export const mapThemeLabel = pref => MAP_THEME_OPTIONS.find(o => o.value === normalizeMapTheme(pref)).label;

// 'light' | 'dark' — det kartet faktisk skal vises i
export function resolveMapTheme(pref, resolvedAppTheme) {
  const p = normalizeMapTheme(pref);
  return p === 'auto' ? (resolvedAppTheme === 'dark' ? 'dark' : 'light') : p;
}

// Google Maps `styles`-valget: mørk stil bare når kartet skal være mørkt
export function mapStylesFor(pref, resolvedAppTheme, darkStyle) {
  return resolveMapTheme(pref, resolvedAppTheme) === 'dark' ? darkStyle : [];
}
